import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimeNgModule } from './primeng/primeng.module';

import { LibWebLayoutTemplatesComponent } from './lib-web-layout-templates.component';
import { AppSideBarTabContentComponent } from './sidebar-menu/app.sidebartabcontent.component';
import { SidebarMenuComponent } from './sidebar-menu/sidebar-menu.component';


import { MenuService } from './sidebar-menu/app.menu.service';
import { PanelMenuModule } from 'primeng/panelmenu';

@NgModule({
  declarations: [
    LibWebLayoutTemplatesComponent,
    SidebarMenuComponent,
    AppSideBarTabContentComponent,
  ],
  imports: [
    CommonModule,
    PrimeNgModule,
    PanelMenuModule,
  ],
  exports: [
    LibWebLayoutTemplatesComponent,
    SidebarMenuComponent
  ],
  providers:[
    MenuService
  ]
})
export class LibWebLayoutTemplatesModule { }
